import { AccordionDetails, AccordionSummary, Box, Checkbox, Typography } from "@mui/material";
import { StyledAccordion } from "./styles";
import { FiArrowDown } from "react-icons/fi";
import { Theme } from "app/shared/utils";

const SelectQuestoes = ({ onChange, categorias = [], selecteds = [], respostas = {} }) => {

    const secoes = {};
    categorias.forEach((categoria) => {
        const secao = categoria.secao_categoria || { id: "sem_secao", nome: "Sem Seção", cor: "#ddd" };
        if (!secoes[secao.id]) {
            secoes[secao.id] = {
                ...secao,
                categorias: [],
            };
        }
        secoes[secao.id].categorias.push(categoria);
    });

    const handleParentClick = (categoria) => (e, checked) => {
        e.stopPropagation();
        const ids = categoria.perguntas
            .filter(pergunta => {
                const resposta = respostas?.[String(pergunta.id)];
                return resposta?.answered;
            })
            .map(pergunta => String(pergunta.id));

        onChange(checked, ids);
    };

    const handleQuestionClick = (perguntaId) => (e, checked) => {
        e.stopPropagation();
        onChange(checked, [String(perguntaId)]); // Normaliza o ID como string
    };

    const getIsAllClick = (categoria) => {
        return categoria.perguntas.every(pergunta => selecteds.includes(String(pergunta.id))); // Compara strings consistentemente
    };

    const getIsSomeClick = (categoria) => {
        return categoria.perguntas.some(pergunta => selecteds.includes(String(pergunta.id))); // Compara strings consistentemente
    };

    const nenhumaResposta = (categoria) => {
        return categoria.perguntas.every(pergunta => !respostas?.[String(pergunta.id)]); // Verifica se não há respostas para a categoria e se ela está desabilitada
    };

    return (
        <>
            {Object.values(secoes).map((secao) => (
                <StyledAccordion key={`secao-${secao.id}`} disableGutters defaultExpanded>
                    <AccordionSummary
                        expandIcon={<FiArrowDown color="black" />}
                        sx={{ backgroundColor: "white" || "#ccc", color: "white" }}
                    >
                        <Typography fontWeight="bold" fontSize="15px" color="black">{secao.nome}</Typography>
                    </AccordionSummary>

                    <AccordionDetails sx={{ padding: 0 }} disableGutters>
                        {secao.categorias.map((categoria) => {
                            const isAllChecked = getIsAllClick(categoria);
                            return (
                                <StyledAccordion
                                    key={`categoria-${categoria.id}`}
                                    disableGutters
                                    disabled={nenhumaResposta(categoria)}
                                    sx={{ boxShadow: "none" }}
                                    defaultExpanded
                                >
                                    <AccordionSummary expandIcon={<FiArrowDown />}>
                                        <Box display="flex" alignItems="center">
                                            <Checkbox
                                                indeterminate={getIsSomeClick(categoria) && !isAllChecked}
                                                checked={isAllChecked}
                                                disabled={nenhumaResposta(categoria)}
                                                onChange={handleParentClick(categoria)}
                                            />
                                            <Typography fontSize="14px" fontWeight="bold">
                                                {categoria.nome}
                                            </Typography>
                                        </Box>
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ padding: "0px" }}>
                                        {categoria.perguntas.map((pergunta) => {
                                            const perguntaId = String(pergunta.id);
                                            const isAnswered = Boolean(respostas?.[perguntaId]?.answered);

                                            return (
                                                <Box
                                                    key={`pergunta-${perguntaId}`}
                                                    display="flex"
                                                    width="100%"
                                                    p="5px 0px"
                                                    pl="50px"
                                                    alignItems="center"
                                                    borderTop={`1px solid ${Theme.colors.gray.ligth}`}
                                                >
                                                    <Checkbox
                                                        disabled={!isAnswered}
                                                        checked={selecteds.includes(perguntaId) && isAnswered}
                                                        onChange={handleQuestionClick(perguntaId)}
                                                    />
                                                    <Typography fontSize="14px">{pergunta.titulo}</Typography>
                                                </Box>
                                            );
                                        })}
                                    </AccordionDetails>
                                </StyledAccordion>
                            );
                        })}
                    </AccordionDetails>
                </StyledAccordion>
            ))}
        </>
    );
};

export default SelectQuestoes;
